import { get, getPBI, postPBI } from "../../../../services/request"

export const getDailyReportLastRefreshed = () => {
    return get('PowerBIReport/GetLastRefreshedDateTime', {
        ReportCode: "DAILYMATRIXREPORT"
    });
}

export const getDailyPowerBIToken = () => {
    return postPBI({
        url: window.configuration.POC_REPORT_FLOWURL,
        headers: { "Accept": "application/json" }
    })
}

export const getDailyEmbedResponse = ({ token, reportId, workspaceId }) => {
    return getPBI({
        url: `${window.configuration.POWER_BI_GROUP_URL}/${workspaceId}/reports/${reportId}`,
        token,
    })
}

export const getDailyMultiResourceTokenResponse = ({ token, reportId, goldenDatasetId, datasetId, reportWorkspaceId, datasetWorkspaceId }) => {
    return postPBI({
        url: window.configuration.POWER_BI_GENERATE_TOKEN_URL,
        token,
        body: JSON.stringify({
            // Must cover both the golden dataset the (thin) report is natively bound to
            // AND the environment dataset it will be dynamically bound to at embed time, each
            // paired with its own workspace in targetWorkspaces — omitting either the
            // target dataset or its workspace here makes the service refuse the rebind.
            datasets: [
                { id: goldenDatasetId },
                { id: datasetId }
            ],
            reports: [{ id: reportId, allowEdit: false }],
            targetWorkspaces: [
                { id: reportWorkspaceId },
                { id: datasetWorkspaceId }
            ]
        })
    })
}
